import { useState, useEffect } from 'react';

const PAYMENT_METHODS_RESERVA = [
  {
    method: 'efectivo',
    label: 'Efectivo en local',
    description: 'Pagás en efectivo al momento de retirar el pedido.',
    icon: 'fa-money-bill-wave',
    surchargeRate: 0
  },
  {
    method: 'transferencia',
    label: 'Transferencia (BROU / Prex)',
    description: 'Transferencia bancaria o Prex. Te enviamos los datos al confirmar.',
    icon: 'fa-building-columns',
    surchargeRate: 0
  },
  {
    method: 'mp_debito',
    label: 'Link de MercadoPago Débito',
    description: 'Te enviamos un link de pago con tarjeta de débito. Recargo: +7,89%.',
    icon: 'fa-credit-card',
    surchargeRate: 0.0789
  },
  {
    method: 'mp_credito',
    label: 'Link de MercadoPago Crédito',
    description: 'Te enviamos un link de pago con tarjeta de crédito. Recargo: +11,54%.',
    icon: 'fa-credit-card',
    surchargeRate: 0.1154
  }
];

const PAYMENT_METHODS_MP = [
  {
    method: 'mercadopago',
    label: 'MercadoPago',
    description: 'Pagás de forma segura con tu tarjeta de débito o crédito a través de MercadoPago.',
    icon: 'fa-credit-card'
  }
];

const PaymentMethodSelector = ({ selectedMethod, onMethodChange, checkoutMode }) => {
  const options = checkoutMode === 'mercadopago' ? PAYMENT_METHODS_MP : PAYMENT_METHODS_RESERVA;
  const defaultMethod = checkoutMode === 'mercadopago' ? 'mercadopago' : 'efectivo';
  const [selected, setSelected] = useState(selectedMethod || defaultMethod);

  useEffect(() => {
    const newDefault = checkoutMode === 'mercadopago' ? 'mercadopago' : 'efectivo';
    setSelected(newDefault);
    const found = options.find(m => m.method === newDefault);
    if (found) onMethodChange({ method: found.method, label: found.label, surchargeRate: found.surchargeRate || 0 });
  }, [checkoutMode]);

  useEffect(() => {
    const found = options.find(m => m.method === selected);
    if (found) onMethodChange({ method: found.method, label: found.label, surchargeRate: found.surchargeRate || 0 });
  }, [selected]);

  const handleSelect = (method) => {
    setSelected(method);
    const found = options.find(m => m.method === method);
    if (found) onMethodChange({ method: found.method, label: found.label, surchargeRate: found.surchargeRate || 0 });
  };

  return (
    <div className="shipping-selector">
      <div className="shipping-options">
        {options.map((option) => (
          <div
            key={option.method}
            className={`shipping-option ${selected === option.method ? 'selected' : ''}`}
            onClick={() => handleSelect(option.method)}
          >
            <div className="shipping-option-content">
              <div className="shipping-icon">
                <i className={`fa-solid ${option.icon}`}></i>
              </div>
              <div className="shipping-details">
                <div className="shipping-label">{option.label}</div>
                <div className="shipping-description">{option.description}</div>
              </div>
              <div className="shipping-check">
                {selected === option.method && <i className="fa-solid fa-circle-check"></i>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;
